module.exports = __webpack_public_path__ + "media/images/landing_page_background-b35e7883459b5343bee93ee0e0759cd2.png";